"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBulkThreadMessages = getBulkThreadMessages;
var _common = require("./common");
// const QUEUE_LENGTH = 5;

function getBulkThreadMessages(url, token, queryParams) {
  // if (typeof window !== 'undefined') {
  //     if (!queryParams || !queryParams.length) {
  //         window.newrelic?.addPageAction('bulk_messages_empty_body', { request_body: queryParams });
  //     }
  //     else if (queryParams.length > QUEUE_LENGTH) {
  //         window.newrelic?.addPageAction('bulk_messages_extra_list', { request_body: queryParams });
  //     }
  // }

  var options = {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token,
      'x-accept-version': 8
    },
    credentials: 'include',
    body: JSON.stringify(queryParams)
  };
  return (0, _common.request)(url, options);
}